import axios from 'axios';
import { get } from 'lodash';
import { HINTS_URL } from '../config/api';
import { getValidToken, authHeader } from './getValidToken';
import { isUser, userId } from '../reducers/userReducer';
import store from '../store';
import { isPaymentKiosk } from '../selectors/configSelectors';
import { isSuccessResultCode } from '../helpers/api';
import { getPayableOrderStatuses, getPayablePaymentStatuses } from '../selectors/paymentKioskSelectors';

export async function getOrders(page = 0) {
  const token = await getValidToken();

  const state = store.getState();

  if (isPaymentKiosk(state) && isUser(state)) {
    const currentUserId = userId(state);

    const payableOrderStatuses = getPayableOrderStatuses(state);

    const payablePaymentStatuses = getPayablePaymentStatuses(state);

    return axios
      .get(`${HINTS_URL}/HintsService/v1.0/rest/ticket/external/ticket/customer/${currentUserId}/page/${page + 1}/pagesize/25`, authHeader(token))
      .then(
        response => {
          let mappedOrders = [];

          if (isSuccessResultCode(response.data)) {
            mappedOrders = get(response, 'data.ticketList', [])
              .filter((o) =>
                (payableOrderStatuses.length === 0 || payableOrderStatuses.includes(o.order_status)) &&
                (payablePaymentStatuses.length === 0 || payablePaymentStatuses.includes(o.payment_status))
              )
              .map((o) => {
                return {
                  'orderId': o.ticket_id,
                  'status': o.order_status,
                  'orderNumber': o.order_number,
                  'dateCreated': o.date_created,
                  'lastUpdateAt': o.last_updated_at,
                  'hash': null
                }
              });
          }

          response.data = {
            ...response.data,
            data: mappedOrders,
            totalElements: mappedOrders.length,
            totalPages: 1
          };

          return response;
        },
        error => console.log(error)
      );
  }
  else {
    return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/tickets/page/${page}`, authHeader(token));
  }
}

export async function getTicketDetails(ticketId) {
  const token = await getValidToken();
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/tickets/${ticketId}/details`, authHeader(token));
}



// WEBPACK FOOTER //
// ./src/services/tickets.js